import { Link } from "react-router-dom";
import { useWorld } from "@/context/WorldContext";
import { fileUrl } from "@/lib/api";
import { catMeta } from "@/lib/constants";
import { cleanSections, itemPage, relationLabel } from "@/lib/infobox";
import { roleLabel } from "@/lib/family";

const ItemValue = ({ item, roleText }) => {
  const { pages, basePath } = useWorld();
  const target = itemPage(item, pages);
  return (
    <div data-testid="infobox-item">
      {target ? (
        <Link to={`${basePath}/p/${target.id}`} data-testid="infobox-item-link"
          className="font-code text-[0.8rem] text-amber-400 bg-amber-950/40 border border-amber-800/50 rounded px-1.5 py-0.5 hover:bg-amber-900/60 transition-colors">{target.title}</Link>
      ) : (
        <span className="text-slate-200">{item.text}</span>
      )}
      {item.role && <span className="text-[11px] font-code text-slate-500 ml-1.5" data-testid="infobox-item-role">· {roleText(item.role)}</span>}
      {item.note && <span className="block text-[11px] text-slate-500 mt-0.5" data-testid="infobox-item-note">{item.note}</span>}
    </div>
  );
};

export const InfoboxView = ({ page }) => {
  const sections = cleanSections(page.sections);
  const meta = catMeta(page.category);
  if (!page.image && !sections.length) return null;
  return (
    <div className="rounded-xl border border-amber-500/30 bg-panel overflow-hidden shadow-[0_0_20px_rgba(245,158,11,0.1)]" data-testid="page-infobox">
      {page.image && <img src={fileUrl(page.image)} alt={page.title} className="w-full aspect-[4/5] object-cover" data-testid="page-image" />}
      {sections.map((s, si) => (
        <section key={si} data-testid={`infobox-view-section-${si}`}>
          <h4 className={`px-4 py-1.5 font-display text-base border-y border-line ${meta.bg} ${meta.text}`}>{s.title || "Details"}</h4>
          <dl className="divide-y divide-line">
            {s.facts.map((f, fi) => (
              <div key={fi} className="grid grid-cols-[100px_1fr] gap-3 px-4 py-2.5 text-sm" data-testid="infobox-fact">
                <dt className="font-code text-[11px] uppercase tracking-wider text-slate-500 pt-0.5 break-words">{f.key}</dt>
                <dd className="space-y-1.5 min-w-0 break-words">{f.items.map((it, ii) => <ItemValue key={ii} item={it} roleText={s.title === "Species Information" ? (r) => relationLabel(r, "out") : roleLabel} />)}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </div>
  );
};
